import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StockReportsLayer from "../components/StockReportsLayer";

const StockReportsPage = () => {
    return (
        <MasterLayout>
            <StockReportsLayer />
        </MasterLayout>
    );
};

export default StockReportsPage;
